import React, { useState, useRef } from "react";
import { useLocation } from "react-router-dom";
import { API } from "aws-amplify";

export default function BugReport({ userInfo, schoolInfo, closeBugReport }) {
  const location = useLocation();
  const fields_ref = useRef({});

  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState(false);
  const [validation, setValidation] = useState({});

  const updateField = (e, key) => {
    if (validation[key]) {
      setValidation((prev) => {
        const updatedValidation = { ...prev };
        delete updatedValidation[key];
        return updatedValidation;
      });
    }
    const input_value = e.target.value;
    fields_ref.current[key] = input_value;
  };

  const validateFields = () => {
    setValidation({});
    const { title, description } = fields_ref.current;
    let isValid = true;
    if (!title || title.trim() === "") {
      setValidation((prev) => ({ ...prev, title: "Title is required." }));
      isValid = false;
    }
    if (!description || description.trim() === "") {
      setValidation((prev) => ({
        ...prev,
        description: "Description is required.",
      }));
      isValid = false;
    }
    return isValid;
  };

  const sendBugReport = async () => {
    if (!validateFields()) return;

    setLoading(true);
    setSuccess(false);
    setError(false);

    const data = {
      title: `Bug Report | ${fields_ref.current.title}`,
      description: fields_ref.current.description,
      browser: navigator.userAgent,
      user: userInfo.email,
      screen: location.pathname,
      schoolName: schoolInfo.name,
      schoolCode: schoolInfo.school_code,
      ...(schoolInfo.school_id && { schoolId: Number(schoolInfo.school_id) }),
      ...(schoolInfo.current_schedule_version_id && {
        scheduleVersionId: Number(schoolInfo.current_schedule_version_id),
      }),
      consoleError: JSON.stringify(window.console.error, null, 2) || "",
    };

    console.log("Sending bug report:", data);

    const apiName = process.env.REACT_APP_ENDPOINT_NAME_V2;
    const url = "/report/bug";
    const myInit = {
      response: true,
      headers: {
        "Content-Type": "application/json",
      },
      body: data,
    };

    try {
      await API.post(apiName, url, myInit);

      setLoading(false);
      setSuccess(true);
      setSent(true);
    } catch (error) {
      console.error("Error sending bug report:", error);
      setLoading(false);
      setError(true);
    }
  };

  return (
    <div className="modal bug-report-modal">
      <div
        className="modal-content"
        style={{ width: "700px", margin: "5% auto 0 auto" }}
      >
        <span className="modal-close-right" onClick={() => closeBugReport()}>
          &times;
        </span>

        <h3>Report a Bug</h3>
        <p>
          Please describe the issue in detail, and our team will work to resolve
          it as quickly as possible. Your feedback helps us improve!
        </p>

        {!sent && (
          <div>
            <form>
              <div>
                <div style={{ flex: 1 }}>
                  <div className={`bug-report-label`}>School</div>
                  <input
                    className={`bug-report-input`}
                    defaultValue={schoolInfo.name || "N/A"}
                    disabled
                  />
                </div>
                <div style={{ flex: 1 }}>
                  <div className={`bug-report-label`}>Screen</div>
                  <input
                    className={`bug-report-input`}
                    defaultValue={location.pathname}
                    disabled
                  />
                </div>
                <div style={{ flex: 1 }}>
                  <div className={`bug-report-label`}>User</div>
                  <input
                    className={`bug-report-input`}
                    defaultValue={userInfo.email || "N/A"}
                    disabled
                  />
                </div>
              </div>

              <div
                className={`bug-report-label ${
                  validation["title"] ? "red-text" : ""
                }`}
                style={{marginTop:'25px'}}
              >
                Subject Line
              </div>
              <input
                placeholder="Insert subject line..."
                className={`bug-report-input ${
                  validation["title"] ? "bright-red-border" : ""
                }`}
                defaultValue={``}
                onChange={(e) => updateField(e, "title")}
                disabled={loading}
              />
              {validation["title"] && (
                <span className="bug-report-validation">
                  {validation["title"]}
                </span>
              )}
              <div
                className={`bug-report-label ${
                  validation["description"] ? "red-text" : ""
                }`}
              >
                Describe your problem
              </div>
              <textarea
                placeholder="Tell us what issue you're having..."
                className={`bug-report-textarea ${
                  validation["description"] ? "bright-red-border" : ""
                }`}
                defaultValue={``}
                onChange={(e) => updateField(e, "description")}
                disabled={loading}
              ></textarea>
              {validation["description"] && (
                <span className="bug-report-validation">
                  {validation["description"]}
                </span>
              )}
            </form>
          </div>
        )}

        {loading && (
          <div
            className="loader"
            style={{
              width: "35px",
              height: "35px",
              display: "block",
              margin: "0 auto",
            }}
          ></div>
        )}

        {success && (
          <div className="alert alert-success">
            Success! Your bug report has been sent successfully. Our team will
            review it and get back to you as soon as possible. Thank you for
            helping us improve!
          </div>
        )}

        {error && (
          <div className="alert alert-error">
            Error! Something went wrong. Please try again.
          </div>
        )}

        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            gap: "10px",
          }}
        >
          <div
            className="btn gray-btn account-settings-btn"
            onClick={() => closeBugReport()}
          >
            Close
          </div>
          {!sent && (
            <div
              className={`btn blue-btn account-settings-btn ${
                loading || sent ? "btn-disabled" : ""
              }`}
              onClick={loading ? () => {} : sendBugReport}
            >
              Send Report
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
